export enum PostalCodesActions {
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
  IMPORT = "import",
}
